import React, { useEffect, useState } from 'react';
import styles from './noResult.scss';
import * as helper from '../../Common/html-helper';
import classNames from 'classnames';
import FilterIcn2021 from '../../Assets/svg/filter_2021';
import { IL10N } from '../../Common/l10n-keys';
import { GlobalState } from '../globalState/globalState';
import { SortContext } from '../globalState/sortContextProvider';
import { ISortContext } from '../globalState/sortContextProvider.d';
import { ViewType } from '../../Common/enums';
import { ArticleTileContext } from '../globalState/articleTileContext';
import { publish } from '../../Common/customEventHelper';
import TabNavigationHelper from '../../Common/tabNavigationHelper';

function NoResult({ l10n, globalState }:
    { l10n: IL10N; viewType: ViewType; isMobile: boolean; globalState: GlobalState }) {
    const sortContext = React.useContext(SortContext) as ISortContext;
    const { viewType, customerType, enableAISorting, persistentCookie } = React.useContext(ArticleTileContext);
    const tabNav = TabNavigationHelper.instance;
    const [message, setMessage] = useState('');

    useEffect(() => {
        setMessage(helper.decodeHTML(l10n.noFilterResult));
    }, [])

    return (
        <div className={styles.no_filter_result}>
            <div>{message}</div>
            <div className={styles.buttons}>
                <div
                    ref={(el) => tabNav.setFocusAtt(el)}
                    className={styles.button}
                    data-testid='noFilterResult_button'
                    data-semantic-id='noFilterResult_button'
                    onClick={() => {
                        sortContext.removeAllGloveSortValues();
                        globalState.removeAllFilters(viewType, customerType, enableAISorting, persistentCookie);
                    }}>{helper.decodeHTML(l10n.clearAllFilters)}</div>
                <div
                    ref={(el) => tabNav.setFocusAtt(el)}
                    className={classNames(styles.button, styles.edit_filter_btn)}
                    data-testid='noFilterResult_edit_button'
                    data-semantic-id='noFilterResult_edit_button'
                    onClick={() => {
                        publish('ESPP.MainSidePanel.ShouldOpen', 'Filter');
                    }}>
                    <FilterIcn2021 />
                    {helper.decodeHTML(l10n.editFilter)}
                </div>
            </div>
        </div>
    );
}

export default NoResult;

